export default "__VITE_ASSET__3027a950__"